import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import MyMixrs from 'srcReact/DiscoverPage/components/MyMixrs'
import MyGroups from 'srcReact/DiscoverPage/components/MyGroups'
import styles from './styles.module.scss'
import { checkNested } from 'srcReact/helpers/validator'
import { urlSearchParams } from 'srcReact/helpers/utils'
import { discoverActions } from 'srcReact/DiscoverPage'
import Tabs from 'srcReact/components/common2/Tabs'
import { commonActions } from 'srcReact/components'

const DiscoverPageContainer = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [mixrScope, setMixrScope] = useState('allmixrs')
  const [groupScope, setGroupScope] = useState('allgroups')
  const [mixrActiveTab, setMixrActiveTab] = useState(2)
  const [groupActiveTab, setGroupActiveTab] = useState(2)
  const [showMixrAccordion] = useState(true)
  const [showGroupAccordion] = useState(true)
  const [groupOrderChanged, setGroupOrderChanged] = useState(false)
  const [mixrOrderChanged, setMixrOrderChanged] = useState(false)
  // const [apiTriggered, setApiTriggered] = useState(false)
  const {
    common: { isMobile, isNative, userLocation },
    organization: { current_organization }
  } = useSelector((state) => state)

  useEffect(() => {
    if (checkNested(current_organization, 'info', 'id')) {
      dispatch(commonActions.addUserPageView(appConstantSettings.DISCOVER_PAGE, current_organization.info.id))
    }
    window.scrollTo(0, 0)
  }, [])
  useEffect(() => {
    // if (!apiTriggered) {
    // nativeapp
    if (isNative) {
      dispatch(
        discoverActions.getDiscoverAll(
          urlSearchParams('id_workplace').toString(),
          urlSearchParams('lat'),
          urlSearchParams('lon'),
          urlSearchParams('lat'),
          urlSearchParams('lon'),
          groupScope,
          mixrScope
        )
      )
      // setApiTriggered(true)
      return
    }

    if (checkNested(current_organization, 'info', 'my_access', 'role_as_workplace_member')) {
      const workplaceIds = current_organization.info.my_access.role_as_workplace_member.workplace_list
      if (workplaceIds && workplaceIds.length >= 1 && userLocation) {
        console.log('calling disvoer api;:', userLocation)
        dispatch(
          discoverActions.getDiscoverAll(
            workplaceIds.toString(),
            userLocation.latitude,
            userLocation.longitude,
            userLocation.latitude,
            userLocation.longitude,
            groupScope,
            mixrScope
          )
        )
        // setApiTriggered(true)
      }
    }
    // }
  }, [current_organization?.info?.id])

  const handleGroupScopeChange = (scope) => {
    setGroupScope(scope)
    setGroupOrderChanged(true)
  }
  const handleMixrScopeChange = (scope) => {
    setMixrScope(scope)
    setMixrOrderChanged(true)
  }

  return (
    <PageContainer pageTitle={t('discover.title')} withFooter={false} withSidebar={true}>
      <div className={`${styles.discoverPageWrapper} ${isNative && styles.nativeDiscoverPageWrapper}`}>
        <div className={styles.myMixrs}>
          <Tabs
            initialActive={mixrActiveTab}
            className={styles.tabs}
            type='boxed'
            // rightContent={renderMixrAccordion()}
            aligned={isMobile ? 'centered' : 'spacebetween'}>
            <div label={t('discover.mymixrs.tabs.bestmatch')} onClick={() => handleMixrScopeChange('bestmatch')}>
              <MyMixrs showAccordion={showMixrAccordion} mixrScope={mixrScope} mixrOrderChanged={mixrOrderChanged} />
            </div>
            <div label={t('discover.mymixrs.tabs.aroundme')} onClick={() => handleMixrScopeChange('aroundme')}>
              <MyMixrs showAccordion={showMixrAccordion} mixrScope={mixrScope} mixrOrderChanged={mixrOrderChanged} />
            </div>
            <div label={t('global.all')} onClick={() => handleMixrScopeChange('allmixrs')}>
              <MyMixrs showAccordion={showMixrAccordion} mixrScope={mixrScope} mixrOrderChanged={mixrOrderChanged} />
            </div>
          </Tabs>
        </div>
        <div className={styles.myGroups}>
          <Tabs
            initialActive={groupActiveTab}
            className={styles.tabs}
            type='boxed'
            // rightContent={renderGroupAccordion()}
            aligned={isMobile ? 'centered' : 'spacebetween'}>
            <div label={t('discover.mygroups.tabs.bestmatch')} onClick={() => handleGroupScopeChange('bestmatch')}>
              <MyGroups
                showAccordion={showGroupAccordion}
                groupScope={groupScope}
                groupOrderChanged={groupOrderChanged}
              />
            </div>
            <div label={t('discover.mygroups.tabs.aroundme')} onClick={() => handleGroupScopeChange('aroundme')}>
              <MyGroups
                showAccordion={showGroupAccordion}
                groupScope={groupScope}
                groupOrderChanged={groupOrderChanged}
              />
            </div>
            <div label={t('global.all')} onClick={() => handleGroupScopeChange('allgroups')}>
              <MyGroups
                showAccordion={showGroupAccordion}
                groupScope={groupScope}
                groupOrderChanged={groupOrderChanged}
              />
            </div>
          </Tabs>
        </div>
      </div>
    </PageContainer>
  )
}

export { DiscoverPageContainer }
